import 'data/storage';
export class SavingService {
    static $inject = ['$rootScope'];
    constructor($rootScope) {
        'ngInject';
        this.$rootScope = $rootScope;
        this.$rootScope.saving = false;
    }
    startSaving() {
        this.$rootScope.saving = true;
    }
    stopSaving() {
        this.$rootScope.saving = false;
    }
}
SavingService.$inject = ['$rootScope'];
